<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <belge-turu-create-or-update v-model="belgeTuru" :errors="errors"></belge-turu-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        name="belge-turu"
                        :fields="fields"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import BelgeTuruCreateOrUpdate from './components/BelgeTuruCreateOrUpdate.vue';
import NetsisApi from '@/api/netsis-operations'

export default {
    components:{
        BCard,
        BelgeTuruCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Belge Türü",key:"Name", thClass:"w-100",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            belgeTuru:{
                Id:null,
                Name:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.belgeTuru.Id = null
            this.belgeTuru.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return NetsisApi.BelgeTuru.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.belgeTuru.Id = item.Id
            this.belgeTuru.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            NetsisApi.BelgeTuru.CreateOrUpdate(this.editing,this.belgeTuru).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} belge türünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    NetsisApi.BelgeTuru.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>